import axios from 'axios';

import { moveAfterItemByItem, isEmptyObject, findInObj } from './utilities/utils';

window.theme.cart = window.theme.cart || {};
const singleItemLimit = 5;
// TO DO: return an error with the response if the quantity is adjusted down

const addItem = async (variantID, quantity, extras = {}) => {
  // TO DO: Implement per-item limits here
  quantity = Math.min(quantity, singleItemLimit);

  // Check if we'd exceed the per-product limit
  const productLimit = findInObj(window.theme.cart.productLimits, pl => {
    return pl.variantIDs.indexOf(variantID) !== -1;
  });

  if (productLimit) {
    const { qtyInCart: PLqtyInCart, limit: PLlimit } = productLimit;

    if (PLqtyInCart >= PLlimit) {
      window.spawnDialog(`Sorry babe, you can only buy ${ PLlimit } of these at a time.`);
      return false;
    }

    const wouldQty = PLqtyInCart + quantity;
    if (wouldQty > PLlimit) {
      // Revise added quantity down
      quantity = Math.min(quantity, PLlimit);
      window.spawnDialog(`Hey babe, max for this is ${ PLlimit }, so we'll just add ${ quantity }.`);
    }
  }

  const result = await axios.post('/cart/add.js', { items: [{ 
    ...{ id: variantID, quantity: quantity },
    ...extras,
  }] });

  // window.analytics.change(result.data, quantity);
  // Handle analytics in augmentCart instead.

  return result;
};

const updateItem = async (key, quantity) => {
  const existingItem = window.theme.cart.items.find(item => item.key === key);
  const limit = existingItem.limit ?? singleItemLimit;

  quantity = Math.min(quantity, limit);
  const diff = quantity - existingItem.quantity;
  if (diff === 0) {
    // No change, return
    return false;
  }

  // Check if we'd exceed the per-product limit
  const productLimit = window.theme.cart.productLimits[existingItem.product_id];
  // Always allow decrements
  if (productLimit && diff > 0) {
    const { qtyInCart: PLqtyInCart, limit: PLlimit } = productLimit;

    if (PLqtyInCart >= PLlimit) {
      // Not allowed - would exceed product limit
      window.spawnDialog(`Sorry babe, you can only buy ${ PLlimit } of these at a time.`);
      return false;
    }
    
    const wouldQty = PLqtyInCart + diff;
    if (wouldQty > PLlimit) {
      // Revise down
      quantity = PLlimit - PLqtyInCart;
      window.spawnDialog(`Hey babe, max for this is ${ PLlimit }, so we'll just add ${ quantity }.`);
    }
  }

  const result = await axios.post('/cart/update.js', { updates: { [key]: quantity } });
  window.analytics.change(existingItem, diff);
  return result;
};

const changeItem = async (key, quantity, extras = {}) => {
  const existingItem = window.theme.cart.items.find(item => item.key === key);
  const limit = existingItem.limit ?? singleItemLimit;

  quantity = Math.min(quantity, limit);
  const diff = quantity - existingItem.quantity;
  if (diff === 0 && isEmptyObject(extras)) {
    // No change, return
    return false;
  }

  // Check if we'd exceed the per-product limit
  const productLimit = window.theme.cart.productLimits[existingItem.product_id];
  // Always allow decrements
  if (productLimit && diff > 0) {
    const { qtyInCart: PLqtyInCart, limit: PLlimit } = productLimit;

    if (PLqtyInCart >= PLlimit) {
      // Not allowed - would exceed product limit
      window.spawnDialog(`Sorry babe, you can only buy ${ PLlimit } of these at a time.`);
      return false;
    }

    const wouldQty = PLqtyInCart + diff;
    if (wouldQty > PLlimit) {
      // Revise down
      quantity = PLlimit - PLqtyInCart;
      window.spawnDialog(`Hey babe, max for this is ${ PLlimit }, so we'll just add ${ quantity }.`);
    }
  }

  const payload = {
    id: key,
    ...quantity && {
      quantity: quantity,
    },
    ...extras,
  };
  const result = await axios.post('/cart/change.js', payload);
  window.analytics.change(existingItem, diff);
  return result;
};

const addOrChange = async(variantID, quantity, extras = {}) => {
  const existingItem = window.theme.cart.items.find(item => item.id === variantID);
  if (existingItem) {
    return await changeItem(existingItem.key, quantity + existingItem.quantity, extras);
  }
  return await addItem(variantID, quantity, extras);
};

const removeItem = async (key) => {
  return await updateItem(key, 0);
};

const getUpsells = async () => {
  const response = await axios.get('/cart?view=nolayout.upsells');
  const upsells = response.data;
  return upsells;
};

const getCart = async () => {
  const response = await axios.get('/cart.js');
  return response.data;
};

const refreshCart = async cart => {
  cart = cart ?? await axios.get('/cart.js').then(resp => resp.data);
  cart = await augmentCart(cart);
  Object.assign(window.theme.cart, cart);

  const event = new CustomEvent('cart:refresh', { detail: cart });
  document.dispatchEvent(event);
  // document.addEventListener('cart:refresh', e => {
  //   const { detail: cart } = e;
  //   Do something with the cart
  // });
};

const decideAfterpay = async () => {
  const response = await axios.get('/cart?view=nolayout.afterpay');
  const showAfterpay = response.data;
  return showAfterpay;
};

const decideKlarna = async () => {
  const response = await axios.get('/cart?view=nolayout.klarna');
  const showKlarna = response.data;
  return showKlarna;
};

const assessIsAllGiftCards = async () => {
  const response = await axios.get('/cart?view=nolayout.is_all_gift_cards');
  const cartIsAllGiftCards = response.data;
  return cartIsAllGiftCards;
};

const getCartAdditionalData = async () => {
  const response = await axios.get('/cart?view=nolayout.additional_data');
  const additionalData = response.data;
  return additionalData;
};

const augmentCart = async cart => {
  // Identify new items
  const prevCart = window.theme.cart;
  const prevCartIDs = prevCart.items.map(i => i.id);
  const prevCartUpsells = prevCart.items.filter(i => i.upsell && i.upsell.show).map(i => i.key);
  cart.items.forEach(item => {
    item.customAttributes = item.customAttributes || {};
    // Switched from using item.key to item.id to prevent add animation when updating line item properties
    item.customAttributes.new = prevCartIDs.indexOf(item.id) === -1;
    if (item.customAttributes.new) {
      window.analytics.change(item, item.quantity);
    }
    // Identify orphaned added upsells, to show upsells on
    if (item.properties._complete_the_set) {
      const originator = cart.items.find(i => i.key === item.properties._complete_the_set);
      if (!originator) {
        item.customAttributes.orphaned = true;
      }
    }
  });

  // Order items based on upsells
  // To Do: Resolve orphaned upsells changing places to the top - occurs because they are unbound 
  // from the originator, and therefore position. 
  // Shouldn't happen often because people are less likely to remove the originator, so leaving it for the moment.
  const addedUpsells = cart.items.filter(i => i.properties._complete_the_set);
  addedUpsells.forEach(upsell => {
    const originator = cart.items.find(i => i.key === upsell.properties._complete_the_set);
    moveAfterItemByItem(cart.items, upsell, originator);
  });

  // To Do: Relocate awaits to a Promise.all to run in parallel
  // To Do: Conditionally run operations (e.g. don't get upsell)
  const operations = [
    getUpsells(),
    decideAfterpay(),
    decideKlarna(),
    assessIsAllGiftCards(),
    getCartAdditionalData(),
  ];

  let upsells, additionalData;

  [
    upsells, 
    cart.showAfterpay,
    cart.showKlarna,
    cart.isAllGiftCards,
    additionalData,
  ] = await Promise.all(operations);

  // if (we want to get upsell) {
    if (upsells) {
      Object.entries(upsells).forEach(([k,v]) => {
        const originatorItem = cart.items.find(item => item.product_id === parseInt(k));
        // To Do: Don't mutate unless different
        originatorItem.upsell = { ...v, 
          ...{ 
            show: false,
            new: (prevCartUpsells.indexOf(originatorItem.key) === -1),
          } 
        };
      });
    }
  // }

  // Decide which upsell(s) to show
  let chooseFromUpsells = cart.items.filter(item => item.upsell);
  // - Don't show dismissed upsells
  chooseFromUpsells = chooseFromUpsells.filter(item => !item.properties._dismiss_set);
  // - No upsells for items that already have an upsell added - so user is not presented with more than 1 upsell per item
  const addedUpsellKeys = addedUpsells.map(upsell => upsell.properties._complete_the_set);
  chooseFromUpsells = chooseFromUpsells.filter(item => addedUpsellKeys.indexOf(item.key) === -1);
  // - Don't show upsells on added upsells, unless orphaned
  chooseFromUpsells = chooseFromUpsells.filter(item => !item.properties._complete_the_set || item.customAttributes.orphaned);
  // - Only show most recent upsell
  chooseFromUpsells = chooseFromUpsells.slice(0,1);

  chooseFromUpsells.forEach(item => item.upsell.show = true);

  cart.items.forEach(item => {
    const additionalDataItem = additionalData.items.find(i => i.key === item.key);
    Object.assign(item, { ...additionalDataItem, ...item });
  });

  // Generate an array of product limits to reference
  const productLimits = {};
  cart.items.filter(item => item.product_limit).forEach(item => {
    productLimits[item.product_id] = productLimits[item.product_id] ?? { limit: item.product_limit, qtyInCart: 0, variantIDs: item.product_variants };
    productLimits[item.product_id].qtyInCart += item.quantity;
  });
  quietLog(productLimits);
  cart.productLimits = productLimits;

  const originalPointsTotal = cart.items.reduce((totalPoints, item) => {
    try {
      const { points, quantity } = item;
      
      if (!(points && points !== '')) {
        return totalPoints;
      }

      return totalPoints + (points * quantity);  
    } catch (err) {
      console.warn(err);
    }
    return totalPoints;
  }, 0);
  cart.points = Math.floor(originalPointsTotal * (cart.total_price / cart.original_total_price));

  cart.items.forEach(item => {
    try {
      const { points, quantity, line_price, original_line_price } = item;
      item.adjustedPoints = Math.floor((points * quantity) * (line_price / original_line_price));  
    } catch(err) {
      console.warn(err);
    }
  });

  return cart;
};

const clearCart = async () => {
  const result = await axios.post('/cart/clear.js');
  // TO DO: Clear analytics
  return result;
};

const doAndRefresh = async (f, args) => {
  const response = await f(...args);

  if (!response) {
    // No action taken
    quietLog('No action taken');
    // TO DO: Return { error: }
    return false;
  }

  const data = response.data;

  // Bandaid way to tell if the response is the cart or not
  // TO DO: Consider mutating existing cart rather than getting the cart fresh.
  const dataIsCart = !!data.token;
  const cart = dataIsCart ? data : await getCart();

  return await refreshCart(cart);
};

window.cartUtils = {
  updateItem: (...args) => doAndRefresh(updateItem, args),
  changeItem: (...args) => doAndRefresh(changeItem, args),
  removeItem: (...args) => doAndRefresh(removeItem, args),
  addItem: (...args) => doAndRefresh(addItem, args),
  addOrChange: (...args) => doAndRefresh(addOrChange, args),
  getUpsells: getUpsells,
  refreshCart: refreshCart,
  clearCart: (...args) => doAndRefresh(clearCart, args),
}

refreshCart();
